<template>
    <b-container>
        <h1>{{ $t('workflow.importProcess') }}</h1>

        <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

        <div v-if="!submitted">
            <div>
                <b-form-group label="Anexo" label-for="file">
                    <b-form-file :lang="$i18n.locale" id="file" ref="file" :placeholder="$t('geral.escolhaArquivo')"
                        v-on:change="handleFileUpload($event)" :no-drop="true"></b-form-file>
                </b-form-group>
            </div>
            <div>
                <b-button variant="green" @click="connectToSSE" :disabled="submitted">
                    {{ $t("geral.confirm") }}
                </b-button>
            </div>
        </div>
        <div v-else>
            <div v-if="$store.getters.darkmode" class="text-center my-2" style="width: 100%; color: white;">
                <clip-loader :loading="true" :color="'white'"></clip-loader>
                <strong>{{ $t("geral.importingDataDontClosePage") }}</strong>
            </div>
            <div v-else class="text-center my-2" style="width: 100%; color: black;">
                <clip-loader :loading="true" :color="'black'"></clip-loader>
                <strong>{{ $t("geral.importingDataDontClosePage") }}</strong>
            </div>
            <b-button class="ml-2" variant="danger" @click="cancel" :disabled="!submitted">
                {{ $t("geral.cancel") }}
            </b-button>
        </div>
        <b-row class="mt-2">
            <b-col>
                <p>{{ $t('geral.importedRowsProcessed') }}: {{ importResultsListCount }}</p>
            </b-col>
            <b-col>
                <p>{{ $t('geral.importedRowsSuccess') }}: {{ importResultsListSuccessCount }}</p>
            </b-col>
            <b-col>
                <p>{{ $t('geral.importedRowsError') }}: {{ importResultsListErrorCount }}</p>
            </b-col>
        </b-row>
        <div>
            <b-table ref="table" class="table-nowrap" :items="importResultsListSorted" :fields="importResultTable.fields"
                :per-page="importResultTable.pagination.perPage" :current-page="importResultTable.pagination.currentPage">
            </b-table>
        </div>
        <table-pagination-props :rowCount="importResultsListCount" :pageOptions="[10, 25, 50, 100, 500, 1000, 10000, 50000]"
            :currentPage.sync="importResultTable.pagination.currentPage"
            :perPage.sync="importResultTable.pagination.perPage">
        </table-pagination-props>
    </b-container>
</template>
<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
// clip-loader
import axios from "axios";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
    name: "WorkflowImportPage",
    props: {
        processId: String,
    },
    components: {
        "success-fade-alert": SuccessFadeAlert,
        "fade-alert-danger": FadeAlertDanger,
        ClipLoader,
        PulseLoader,
        TablePaginationProps: () =>
            import("@/components_rms/base/TablePaginationProps.vue"),
    },
    data: function () {
        return {
            submitted: false,
            file: null,
            importacaoId: null,
            alert: {
                error: "",
                success: "",
            },
            latitude: 0.0,
            longitude: 0.0,
            abortController: null,
            importResultTable: {
                fields: [
                    {
                        key: "date",
                        filterKey: "Date",
                        label: "Data importação",
                        // thStyle: "text-align: center; width: 180px;",
                        tdClass: this.tdColor,
                        formatter: (value) => {
                            return this.formatDatetimePtBr(new Date(value));
                        },
                    },
                    {
                        key: "lineNumber",
                        filterKey: "lineNumber",
                        label: "Linha",
                        // thStyle: "text-align: center; width: 180px;",
                        tdClass: this.tdColor,
                    },
                    {
                        key: "success",
                        filterKey: "success",
                        label: "Sucesso",
                        // thStyle: "text-align: center; width: 120px;",
                        tdClass: this.tdColor,
                        formatter: (value) => {
                            return value ? "Sucesso" : "Erro";
                        },
                    },
                    {
                        key: "message",
                        filterKey: "message",
                        label: "Mensagem",
                        // thStyle: "text-align: center; width: 120px;",
                        tdClass: this.tdColor,
                    },
                ],
                items: [],
                pagination: {
                    currentPage: 1,
                    perPage: 10,
                },
            }
        };
    },
    beforeDestroy() {
        this.disconnectFromSSE(); // Chama a função para desconectar antes de destruir o componente
    },
    computed: {
        importResultsListCount() {
            return this.importResultTable.items.length;
        },
        importResultsListErrorCount() {
            return this.importResultTable.items.length - this.importResultsListSuccessCount;
        },
        importResultsListSuccessCount() {
            return this.importResultTable.items.filter(f => f.success).length;
        },
        importResultsListSorted() {
            return this.importResultTable.items.sort((a1, a2) => a2.lineNumber - a1.lineNumber)
        },
    },
    mounted() {
        this.getPosition();
    },
    methods: {
        disconnectFromSSE() {
            console.log('disconnectFromSSE')
            console.log(this.abortController)
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = null;
            }
            if (this.eventSource) {
                this.eventSource.close(); // Fecha a conexão SSE
                this.eventSource = null; // Limpa a referência ao objeto EventSource
            }
        },
        async connectToSSE() {
            try {
                this.submitted = true;
                this.importResultTable.items = [];

                console.log('INICIO');
                this.abortController = new AbortController();

                let formData = new FormData();
                formData.append("file", this.file);

                const url = `${this.$store.getters.urlWorkflow}/v2/importProcess?processId=${this.processId}&latitude=${this.latitude}&longitude=${this.longitude}`;
                const response = await fetch(url,
                    {
                        method: 'POST',
                        body: formData,
                        signal: this.abortController.signal,
                        headers: {
                            "Authorization": `Bearer ${this.$store.getters.token}`,
                            // "Content-Type": "multipart/form-data",
                        },
                    });
                /*
                const response = await fetch(
                    // `${this.$store.getters.urlWorkflow}/v2/importProcess/${this.processId}/${this.latitude}/${this.longitude}`,
                    `http://localhost:5242/AsyncEnumerable/`,
                    {
                        signal: this.abortController.signal
                    });
                */
                const reader = response.body.getReader(); // Obtem um leitor assíncrono para o stream
                const decoder = new TextDecoder();

                while (true) {
                    const { done, value } = await reader.read(); // Lê um chunk do stream de forma assíncrona
                    if (done) break; // Se o stream terminar, sai do loop

                    const responseChunkString = decoder.decode(value);
                    const responseChunkArray = responseChunkString.split("},{");

                    for (const jsonObject of responseChunkArray) {
                        if (jsonObject[0] == "[" || jsonObject[0] == ",")
                            jsonObject = jsonObject.slice(2)
                        if (jsonObject[0] == "{")
                            jsonObject = jsonObject.slice(1)
                        if (jsonObject[jsonObject.length - 1] == "]")
                            jsonObject = jsonObject.slice(0, -2)
                        if (jsonObject[jsonObject.length - 1] == "}")
                            jsonObject = jsonObject.slice(0, -1)

                        const eventData = JSON.parse(`{${jsonObject}}`); // Parseia o JSON
                        this.importResultTable.items.push(eventData);
                    }

                    // this.weatherForecasts.push(eventData); // Adiciona o evento recebido ao array de eventos
                }
                /*console.log(response)
                const reader = response.body.getReader(); // Obtem um leitor assíncrono para o stream
                const decoder = new TextDecoder();

                while (true) {
                    const { done, value } = await reader.read(); // Lê um chunk do stream de forma assíncrona
                    if (done) break; // Se o stream terminar, sai do loop

                    const chunk = decoder.decode(value); // Decodifica o chunk em texto
                    console.log(chunk)
                    if (chunk[0] == "[" || chunk[0] == ",")
                        chunk = chunk.slice(1)
                    if (chunk[chunk.length - 1] == "]")
                        chunk = chunk.slice(0, -1)

                    const eventData = JSON.parse(chunk); // Parseia o JSON
                    this.importResultTable.items.push(eventData);
                    // this.weatherForecasts.push(eventData); // Adiciona o evento recebido ao array de eventos
                }*/
                this.submitted = false;
            }
            catch (error) {
                console.log('Error CATCH!');
                console.log(error);
                // res.status(400).send(error.message);
                this.submitted = false;
            }
        },
        show() {
            this.getPosition();
        },
        save() {
            if (this.file != null) {
                this.submitted = true;
                let formData = new FormData();
                formData.append("file", this.file);
                this.$apiWorkflow
                    .post(
                        `/importProcess/${this.processId}/${this.latitude}/${this.longitude}`,
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    )
                    .then((response) => {
                        this.alert.success = "Processo importado com sucesso!";
                        this.$refs.successFadeAlert.show();
                        this.file = null;
                        this.submitted = false;
                        this.$emit("refreshData");
                    })
                    .catch((error) => {
                        console.log(error.response);
                        if (error.response) {
                            this.alert.error = error.response.data.detail;
                            this.$refs.fadeAlertDanger.show();
                            this.submitted = false;
                        } else {
                            this.alert.error = error.message;
                            this.$refs.fadeAlertDanger.show();
                            this.submitted = false;
                        }
                    });
            }
        },
        cancel() {
            this.disconnectFromSSE();
            this.file = null;
        },
        handleFileUpload(e) {
            this.file = e.target.files[0];
        },
        getPosition() {
            navigator.geolocation.getCurrentPosition(this.success, this.error);
        },
        success(pos) {
            var crd = pos.coords;
            this.latitude = crd.latitude;
            this.longitude = crd.longitude;
        },
        error(err) {
            console.warn("ERROR(" + err.code + "): " + err.message);
        },
        tdColor(value, key, item) {
            if (!item.success) return "table-td-bg-red";
            return "table-td-bg-green";
        },
    },
};
</script>
<style scoped>.right {
    text-align: right;
    width: 100%;
}</style>